import { factoryService, getLocalizationChoiceId, getLocalizationMapping, getOcplcConfiguration, getTOFProgramManagement, localizationAvailability, localizationDefault, materialAvailability, modelAvailability, parameters } from "actions/ocplcAction";
import { getModelColumns } from "./OcplcEditColumns/columnsConfig";
import { getMaterialColumns } from "./OcplcEditColumns/materialColumnsConfig";
import { getFactoryColumns } from "./OcplcEditColumns/factoryServicesColumns";
import { getParameterColumns } from "./OcplcEditColumns/parametersColumns";
import { VERSION_0002 } from "constants/ocplcConstants";
import { getLocalizationDefaultColumns } from "./OcplcEditColumns/getLocalizationDefaultColumns";
import { getLocalizationAvailabilityColumns } from "./OcplcEditColumns/getLocalizationAvailabilityColumns";

// Table Type Constants
export const TABLE_TYPES = {
    MODEL: 'Model Availability',
    MATERIAL: 'Material Availability',
    FACTORY: 'Factory Services',
    PARAMETERS: 'Parameters',
    TOF_PROGRAM_MANAGEMENT: 'TOF Program Management',
    LOCALIZATION_MAPPING: 'Localization Mapping',
    LOCALIZATION_CHOICE_ID: 'Localization Choice ID Customization',
    OCPLC_CONFIGURATION: 'OCPLC Configuration',
    LOCDEFAULT: 'Default Localization',
    LOCAVAILABILITY: 'Available Localization',
};

const createTableConfig = ({ fullDataKey, filteredDataKey, getColumns, loadAction, getParams }) => ({
    selector: state => ({
        fullData: state.ocplc[fullDataKey],
        filteredData: state.ocplc[filteredDataKey],
    }),
    getColumns,
    loadData: (dispatch, params) => dispatch(loadAction(...params)),
    getParams,
});

export const tableConfigMap = {
    [TABLE_TYPES.MODEL]: createTableConfig({
        fullDataKey: 'modelAvailabilityData',
        filteredDataKey: 'filteredModelData',
        getColumns: getModelColumns,
        loadAction: modelAvailability,
        getParams: ({ version, region, kmatId, productGroup, productLineID }) =>
            [version, region, kmatId, productGroup, productLineID, true],
    }),

    [TABLE_TYPES.MATERIAL]: createTableConfig({
        fullDataKey: 'materialAvailabilityData',
        filteredDataKey: 'filteredMaterialData',
        getColumns: getMaterialColumns,
        loadAction: materialAvailability,
        getParams: ({ version, region, kmatId, productGroup, selectedCategory }) =>
            [version, region, productGroup, kmatId, selectedCategory, 0, 9999, "", "", "", true],
    }),

    [TABLE_TYPES.FACTORY]: createTableConfig({
        fullDataKey: 'factoryServicesData',
        filteredDataKey: 'filteredFactoryData',
        getColumns: getFactoryColumns,
        loadAction: factoryService,
        getParams: ({ version, region, productGroup, kmatId }) =>
            [version, region, productGroup, kmatId, true],
    }),

    [TABLE_TYPES.TOF_PROGRAM_MANAGEMENT]: createTableConfig({
        fullDataKey: 'tofProgramManagementData',
        filteredDataKey: 'filteredTOFPMData',
        getColumns: getParameterColumns,
        loadAction: getTOFProgramManagement,
        getParams: ({ version, region }) => [ version, region, true],
    }),
    [TABLE_TYPES.LOCDEFAULT]: createTableConfig({
        fullDataKey: 'localizationDefaultData',
        filteredDataKey: 'filteredLocalizationDefaultData',
        getColumns: getLocalizationDefaultColumns,
        loadAction: localizationDefault,
        getParams: ({ version, region, kmatId, selectedProductGroup }) => [version, region, '', selectedProductGroup,  kmatId ? kmatId : '', true],
    }),
     [TABLE_TYPES.LOCAVAILABILITY]: createTableConfig({
        fullDataKey: 'localizationAvailabilityData',
        filteredDataKey: 'filteredLocalizationAvailabilityData',
        getColumns: getLocalizationAvailabilityColumns,
        loadAction: localizationAvailability,
        getParams: ({ version, region, kmatId, selectedProductGroup }) => [
            version,
            region,
            kmatId ? kmatId : '',
            selectedProductGroup,
            true
        ],
    }),
    [TABLE_TYPES.LOCALIZATION_MAPPING]: createTableConfig({
        fullDataKey: 'localizationMappingData',
        filteredDataKey: 'filteredLocalizationMappingData',
        getColumns: getParameterColumns,
        loadAction: getLocalizationMapping,
        getParams: ({ version, region }) => [ version, region, true],
    }),
    [TABLE_TYPES.LOCALIZATION_CHOICE_ID]: createTableConfig({
        fullDataKey: 'localizationChoiceIdData',
        filteredDataKey: 'filteredLocalizationChoiceIdData',
        getColumns: getParameterColumns,
        loadAction: getLocalizationChoiceId,
        getParams: ({ version, region }) => [ version, region, true],
    }),
    [TABLE_TYPES.OCPLC_CONFIGURATION]: createTableConfig({
        fullDataKey: 'ocplcConfigurationData',
        filteredDataKey: 'filteredOcplcConfigurationData',
        getColumns: getParameterColumns,
        loadAction: getOcplcConfiguration,
        getParams: ({ version }) => [ version, true],
    }),
};
